import React from 'react';
import PropTypes from 'prop-types';
import Blob from 'components/shared/Blob';
import Column from 'components/shared/Column';
import Row from 'components/shared/Row';
import styles from './styles.module.scss';

function PageTwoColumns(props) {
  return (
    <Row styles={[styles.topPaddedRow, ...props.styles]}>
      <Column lg={6} sm={0} styles={[styles.blobColumn]}>
        <Blob />
      </Column>

      <Column lg={6} sm={12}>
        {props.children}
      </Column>
    </Row>
  );
}

PageTwoColumns.propTypes = {
  children: PropTypes.any,
  styles: PropTypes.array
};

PageTwoColumns.defaultProps = {
  children: null,
  styles: []
};

export default PageTwoColumns;
